import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=56cb7df0&scoped=true"
import script from "./Statements.vue?vue&type=script&lang=ts"
export * from "./Statements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb7df0",
  null
  
)

export default component.exports